import { useEffect, useState, useCallback } from 'react';
import faceIO from '@faceio/fiojs';

export const useFaceIO = () => {
  const [faceioInstance, setFaceioInstance] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState(null);

  const initializeFaceIO = useCallback(async () => {
    try {
      const publicId = process.env.REACT_APP_FACEIO_PUBLIC_ID;
      if (!publicId || publicId === 'fioaXXXX') {
        if (process.env.NODE_ENV === 'development') {
          console.warn('FACEIO Public ID not configured - using demo mode');
        }
        setIsInitialized(true);
        return;
      }
      const instance = new faceIO(publicId);
      setFaceioInstance(instance);
      setIsInitialized(true);
    } catch (err) {
      setError(`Failed to initialize FaceIO: ${err.message}`);
      if (process.env.NODE_ENV === 'development') {
        console.error('FaceIO initialization error:', err);
      }
      setIsInitialized(true);
    }
  }, []);

  useEffect(() => {
    initializeFaceIO();
  }, [initializeFaceIO]);

  return { faceioInstance, isInitialized, error };
};
